import { useContext } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedName from 'I18n/components/FormattedName';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIList from 'UIComponents/list/UIList';
import { P, TextAlignLeft } from './TwoFactorStyledComponents';
import { TwoFactorRecoveryContext } from '../../contexts/twoFactorRecovery';
import { TwoFactorRecoveryAlerts } from './TwoFactorRecoveryAlerts';
import { View } from 'foundations-components/components/View';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AdminName = ({
  obfuscatedEmail,
  adminName
}) => obfuscatedEmail != null ? /*#__PURE__*/_jsx(_Fragment, {
  children: obfuscatedEmail
}) : /*#__PURE__*/_jsx(FormattedName, {
  givenName: adminName.firstName,
  familyName: adminName.lastInitial
});
export const TwoFactorRecoveryAdmin = () => {
  const {
    admins,
    isRecovering,
    recoveryAttempted,
    onClickAdminRecovery,
    recoverySent
  } = useContext(TwoFactorRecoveryContext);
  return /*#__PURE__*/_jsxs(UIDialogBody, {
    children: [/*#__PURE__*/_jsxs(TextAlignLeft, {
      children: [/*#__PURE__*/_jsx(P, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reAuth.recovery.recoveryAdmin.form.description"
        })
      }), admins && /*#__PURE__*/_jsx(UIList, {
        styled: true,
        children: admins.map((admin, index) => /*#__PURE__*/_jsx(View, {
          marginBlockEnd: "300",
          as: "div",
          children: /*#__PURE__*/_jsx(AdminName, Object.assign({}, admin))
        }, index))
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reAuth.recovery.recoveryAdmin.form.descriptionMore"
        })
      })]
    }), /*#__PURE__*/_jsx(TwoFactorRecoveryAlerts, {}), /*#__PURE__*/_jsx(UILoadingButton, {
      "data-test-id": "admin-recovery-initiate-button",
      disabled: !isRecovering && recoveryAttempted,
      loading: isRecovering,
      onClick: onClickAdminRecovery,
      resultIcon: !recoveryAttempted || recoverySent ? 'success' : 'remove',
      type: "button",
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reAuth.recovery.form.recoveryAdminButton"
      })
    })]
  });
};